import i18nx from '@vimcar/shared-utils/i18nx'

import translationsDeDe from './translations/de.json'
import translationsEnGb from './translations/en.json'

i18nx.addResources('de-DE', translationsDeDe)
i18nx.addResources('en-GB', translationsEnGb)

i18nx.changeLanguage('de-DE')

export default i18nx
